var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 4.66683H2.33333C2.14924 4.66683 2 4.51759 2 4.3335V3.66683C2 3.48273 2.14924 3.3335 2.33333 3.3335H13.6667C13.8508 3.3335 14 3.48273 14 3.66683V4.3335C14 4.51759 13.8508 4.66683 13.6667 4.66683ZM14 8.3335V7.66683C14 7.48273 13.8508 7.3335 13.6667 7.3335H2.33333C2.14924 7.3335 2 7.48273 2 7.66683V8.3335C2 8.51759 2.14924 8.66683 2.33333 8.66683H13.6667C13.8508 8.66683 14 8.51759 14 8.3335ZM14 11.6668V12.3335C14 12.5176 13.8508 12.6668 13.6667 12.6668H2.33333C2.14924 12.6668 2 12.5176 2 12.3335V11.6668C2 11.4827 2.14924 11.3335 2.33333 11.3335H13.6667C13.8508 11.3335 14 11.4827 14 11.6668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalView);
export default __webpack_public_path__ + "static/media/normal-view.2b5a7b06b45987c0e889c8b11f7d2ac5.svg";
export { ForwardRef as ReactComponent };